module.exports = __webpack_public_path__ + "static/13-1763f45bccfac9c1996c6dcbf77e7b73.png";